import React from "react";
import { Link } from "react-router-dom";

const SideBar = () => {
  return (
    <div className="sm:min-h-full overflow-y-hidden overflow-x-hidden pb-5 sm:pb-0 sm:w-[350px] shadow bg-white text-black font-Montserrat">
      <div className="flex flex-col pl-4 pt-4">
        <div className="flex flex-col">
          <Link
            to={`/profile`}
            className="flex gap-2 pt-4 rounded-md"
            // style="text-decoration: none; font-size: 1.2rem; font-weight: 600;"
          >
            <span className="w-8 h-8">
              <svg
                viewBox="0 0 48 48"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M24.0003 7C20.1343 7 17.0003 10.134 17.0003 14C17.0003 17.866 20.1343 21 24.0003 21C27.8663 21 31.0003 17.866 31.0003 14C31.0003 10.134 27.8663 7 24.0003 7ZM13.0003 14C13.0003 7.92487 17.9252 3 24.0003 3C30.0755 3 35.0003 7.92487 35.0003 14C35.0003 20.0751 30.0755 25 24.0003 25C17.9252 25 13.0003 20.0751 13.0003 14ZM24.0003 33C18.0615 33 13.0493 36.9841 11.4972 42.4262C11.3457 42.9573 10.8217 43.3088 10.2804 43.1989L8.32038 42.8011C7.77914 42.6912 7.4266 42.1618 7.5683 41.628C9.49821 34.358 16.1215 29 24.0003 29C31.8792 29 38.5025 34.358 40.4324 41.628C40.5741 42.1618 40.2215 42.6912 39.6803 42.8011L37.7203 43.1989C37.179 43.3088 36.6549 42.9573 36.5035 42.4262C34.9514 36.9841 29.9391 33 24.0003 33Z"
                ></path>
              </svg>
            </span>
            <span>Profile</span>
          </Link>
          <Link
            to={`/profile/application`}
            className="flex gap-2 pt-4 rounded-md"
            // style="text-decoration: none; font-size: 1.2rem; font-weight: 600;"
          >
            <span className="w-8 h-8">
              <svg
                viewBox="0 0 48 48"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M24 37.4a13.4 13.4 0 1 0 0-26.8 13.4 13.4 0 0 0 0 26.8ZM40.5 24a16.5 16.5 0 1 1-33 0 16.5 16.5 0 0 1 33 0Z"
                ></path>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M27.13 27.18a2 2 0 0 0 .93-1.32l1.84-9.33a.6.6 0 0 0-.9-.63l-8.14 4.92a2 2 0 0 0-.92 1.32l-1.84 9.33c-.1.52.45.9.9.63l8.13-4.92Zm-5.04-.45 3.11-1.89.7-3.57-3.1 1.89-.7 3.57Z"
                ></path>
              </svg>
            </span>
            <span>Application</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
